module.exports = __webpack_public_path__ + "img/logo.cc05526.png";